export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8123.78aebda8.jpg";